import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';

@Pipe({name: 'chameleon'})
export class ChameleonPipe implements PipeTransform {

  dateRegex = /^[\d]{4}[-][\d]{2}[-][\d]{2}[T][\d]{2}[:][\d]{2}[:][\d]{2}[.][\d]{1,7}$/;

  constructor (private decimalPipe: DecimalPipe, private datePipe: DatePipe) {}

  transform(value: any) {
    switch(typeof(value)) {
      case "string":
        if      (value === 'true') {return true;} // Check if string is really a boolean
        else if (value === 'false') {return false;} // Check if string is really a boolean
        else if (value === 'null') {return null;} // Check if string is really null
        else if (value === 'undefined') {return undefined;} // Check if string is really undefined
        else if (this.dateRegex.test(value)) {return this.datePipe.transform(value,'MM-dd-yyyy');} // Check if string is really date, if so return using date pipe
        else if (!isNaN(+value)) {return this.decimalPipe.transform(value);} // Check if string is really a number, maybe do some additional formatting
        else {return value;}
      default:
        return value;
    }
  }
}